var _a;
import api from "../../utils/api/api.utils";
import { generateApi } from "../generators/generator.api";
import { GENERATOR_PARAMS } from "./bankAccount.constants";
export var getDetail = (_a = generateApi(GENERATOR_PARAMS), _a.getDetail), getInfiniteLoad = _a.getInfiniteLoad;
export var getAllMissingKYCs = function () {
    return api.get("/".concat(GENERATOR_PARAMS.basePathEntity, "/missing-kycs"), { isV2: true });
};
export var removeBankAccount = function (id) {
    return api.patch("/".concat(GENERATOR_PARAMS.basePathEntity, "/").concat(id, "/remove"), { isV2: true });
};
